import { Input } from "@synthesis/shared-ui";

import { createApplicationApplicantInputMasks } from "../../create-application-applicant-input-masks";
import { ApplicantCheckbox } from "./create-application-applicant-form-controls";
import { CreateApplicationFormField, CreateApplicationFormSection } from "../create-application-form-layout";

type ApplicantBankSectionProps = {
  namePrefix?: "payer";
  title?: string;
  showAnotherPayerCheckbox?: boolean;
};

export const ApplicantBankSection = ({ namePrefix, title = "Банковские реквизиты", showAnotherPayerCheckbox }: ApplicantBankSectionProps) => {
  const isPayer = namePrefix === "payer";
  const field = (applicantName: string, payerName: string) => (isPayer ? payerName : applicantName);

  return (
    <CreateApplicationFormSection title={title} required={isPayer}>
      <CreateApplicationFormField label="Банк" required>
        <Input name={field("bankName", "payerBankName")} placeholder="Наименование банка" />
      </CreateApplicationFormField>

      <div className="grid gap-4 lg:grid-cols-3">
        <CreateApplicationFormField label="БИК" required>
          <Input name={field("bik", "payerBik")} placeholder="(9 цифр)" settings={createApplicationApplicantInputMasks.bik} />
        </CreateApplicationFormField>
        <CreateApplicationFormField label="Расчётный счёт" required>
          <Input
            name={field("settlementAccount", "payerSettlementAccount")}
            placeholder="(20 цифр)"
            settings={createApplicationApplicantInputMasks.settlementAccount}
          />
        </CreateApplicationFormField>
        <CreateApplicationFormField label="Корреспондентский счёт" required>
          <Input
            name={field("correspondentAccount", "payerCorrespondentAccount")}
            placeholder="(20 цифр)"
            settings={createApplicationApplicantInputMasks.correspondentAccount}
          />
        </CreateApplicationFormField>
      </div>

      {showAnotherPayerCheckbox && <ApplicantCheckbox name="paymentByAnotherOrganization" label="Оплату производит другая организация" />}
    </CreateApplicationFormSection>
  );
};
